import { IEmailTemplate } from 'susy-common/models';
import {
    EmailTemplateAction,
    EmailTemplatesActionType,
} from '../actionTypes/emailTemplates';

const emailTemplateReducer = (
    state: Array<IEmailTemplate> = [],
    action: EmailTemplateAction
): Array<IEmailTemplate> => {
    switch (action.type) {
        case EmailTemplatesActionType.GET_ALL_EMAIL_TEMPLATES: {
            return action.payload as Array<IEmailTemplate>;
        }
        case EmailTemplatesActionType.UPDATE_EMAIL_TEMPLATE: {
            return state.map((emailTemplate) => {
                const updatedEmailTemplate = action.payload as IEmailTemplate;
                if (updatedEmailTemplate._id === emailTemplate._id) {
                    return updatedEmailTemplate;
                } else {
                    return emailTemplate;
                }
            });
        }
        default: {
            return state;
        }
    }
};

export default emailTemplateReducer;
